import openApiClient, { type ClientOptions } from "openapi-fetch";

import type { paths } from "./openapi";

/**
 * Creates and configures an OpenAPI client for the smarta documents API.
 *
 * @returns A configured OpenAPI client instance.
 */
export function createOpenApiClient(options?: ClientOptions) {
  return openApiClient<paths>(options);
}
export type OpenApiClient = ReturnType<typeof createOpenApiClient>;
